import { getOrgId, OrganizationId, SmapiVendorAccount } from "api";
import { Credentials } from "auth";
import { Organization } from "generated/graphql";
import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";
import { State } from "redux/state";

export type AddPublishingAccount = "ADD_PUBLISHING_ACCOUNT";
export const ADD_PUBLISHING_ACCOUNT: AddPublishingAccount = "ADD_PUBLISHING_ACCOUNT";
export type AddPublishingAccountEnd = "ADD_PUBLISHING_ACCOUNT_END";
export const ADD_PUBLISHING_ACCOUNT_END: AddPublishingAccountEnd = "ADD_PUBLISHING_ACCOUNT_END";

export interface AddPublishingAccountToOrganizationAction extends Action {
    payload: {
        organizationId: string;
        account: { smapi: SmapiVendorAccount };
        credentials: Credentials;
    };
    type: AddPublishingAccount;
}

export function addPublishingAccountToOrganization(
    organization: OrganizationId,
    account: { smapi: SmapiVendorAccount }
): ThunkAction<void, State, undefined, AddPublishingAccountToOrganizationAction> {
    return (dispatch: Dispatch<AddPublishingAccountToOrganizationAction>, getState) => {
        const state = getState();
        dispatch(addPublishingAccountWithCredentials(state.auth.credentials, organization, account));
    };
}

function addPublishingAccountWithCredentials(
    credentials: Credentials,
    organization: OrganizationId,
    account: { smapi: SmapiVendorAccount }
): AddPublishingAccountToOrganizationAction {
    return {
        payload: {
            account,
            credentials,
            organizationId: getOrgId(organization)
        },
        type: ADD_PUBLISHING_ACCOUNT
    };
}

export interface AddPublishingAccountToOrganizationEndAction extends Action {
    payload: {
        organization?: Organization;
        error?: Error;
    };
    type: AddPublishingAccountEnd;
}

export function addPublishingAccountToOrganizationEnd(
    error: Error,
    organization?: Organization
): AddPublishingAccountToOrganizationEndAction {
    return {
        payload: {
            error,
            organization
        },
        type: ADD_PUBLISHING_ACCOUNT_END
    };
}
